import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateCaseTotalPrice, updateNoOfSets } from "../../../api/caseApi";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { updateNoOfSetsSchema } from "../schema/updateNoOfSetsSchema";
import * as yup from "yup";
const UpdateCaseTotalPriceDialog = ({ open, onClose, caseId, getCaseData }) => {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        totalCasePrice: yup.number().positive().required(),
      })
    ),
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseId = caseId;
    reset({ ...defaultValues });
  }, [caseId, reset]);

  const onSubmit = async (values) => {
    await updateCaseTotalPrice(caseId, values.totalCasePrice);
    await getCaseData();
    onClose();
  };

  return (
    <div>
      <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle> Update Case Total Price</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  type="number"
                  label="Total Case Price"
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.totalCasePrice}
                  helperText={errors.totalCasePrice?.message}
                  {...register("totalCasePrice")}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton theme="purple" onClick={onClose}>
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default UpdateCaseTotalPriceDialog;
